/* eslint-disable import/order */
/* eslint-disable camelcase */
import { Box, Button, Typography, makeStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import styles from '../../../resources/theme/users'
import colors from '../../../assets/colors'
import FormGroupLaundry from './Forms/Laundry'
import FormGroupUser from './Forms/User'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { fetchLaundryClients } from '../LaundryClientActions'

const useStyles = makeStyles({
  sectionTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
    width: '100%',
  },
})

const Form = ({ data, onSubmit, formEdit }) => {
  const classes = filterStylesComponents()
  const sectionClasses = useStyles()
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    id: '',
    name: '',
    email: '',

    cep: '',
    street: '',
    number: '',
    neighborhood: '',
    complement: '',
    city: '',
    uf: '',
    phone: '',
    cpf_cnpj: '',
    description: '',

    country_code: '',
    locale: '',
    timezone: '',

    logo: '',

    manager_id: null,
    manager_cpf: '',
    manager_email: '',
    manager_name: '',
    manager_password: '',
    manager_has_password: false,

    status: 2,
    status_id: 2,
    expiration_date: '',
  })

  const initForm = () => {
    setForm(prev => ({
      ...prev,
      ...data,
    }))
  }

  useEffect(() => {
    dispatch(fetchLaundryClients())
  }, [])

  const handleChange = e => {
    e.preventDefault()

    const { name, value } = e.target

    setForm(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = e => {
    e.preventDefault()

    onSubmit && onSubmit(form)
  }

  useEffect(() => {
    if (formEdit && !data) return

    initForm()
  }, [formEdit, data])

  return (
    <form onSubmit={handleSubmit}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography className={sectionClasses.sectionTitle}>
              Dados da lavanderia
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormGroupLaundry
              form={form}
              setForm={setForm}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography className={sectionClasses.sectionTitle}>
              Dados do gerente
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormGroupUser form={form} handleChange={handleChange} />
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-end">
          <Button color="primary" type="submit" className={classes.btnSalvar}>
            Salvar
          </Button>
        </Grid>
      </Box>
    </form>
  )
}

export default withStyles(styles)(Form)
